export default __webpack_public_path__ + "static/media/penguin.083fbe31.webp";